import React from 'react';
import buttonClose from "../../../assets/images/shared/modals/button-close.svg";

const EditData = ({ showModalEditData, closeModalEditData, product,productName, categoryName,scalemodel, codbalanza, context, onConfirm, }) => {
  if (!showModalEditData) return null; // No renderiza si el modal no está activo

  const message =
  context === "Balanza"
    ? `¿Está seguro que desea editar la balanza con código ${codbalanza}?`
    : context === "Productos"
    ? `¿Está seguro que desea editar el producto ${product}?`
        : context === "ModeloBalanzas"
    ? `¿Está seguro que desea editar el modelo de balanza ${scalemodel}?`
    : context === "Producto"
    ? `¿Está seguro que desea eliminar el producto ${productName}?`
     : context === "Categoria"
    ? `¿Está seguro que desea eliminar la categoría con ID ${categoryName}?`
    
    : "¿Está seguro que desea realizar esta acción?"; // Mensaje por defecto

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center w-full bg-black bg-opacity-50">
      <div className="flex flex-col max-w-[350px] h-auto p-5 bg-white shadow-lg rounded-3xl ">
        <div className='flex justify-end '>
          <button
            onClick={closeModalEditData}
            className="rounded-md"
          >
            <img src={buttonClose} alt="Cerrar" />
          </button>
        </div>
        <div className='flex flex-col items-center justify-center p-5'>
          <p className="mb-11 text-[#007696] text-[16px] text-center font-itcdemi">
            {message}
          </p>

          <button onClick={onConfirm} className='bg-green text-white font-itcdemi text-lg rounded-[8px] w-[189px] h-[39.02px] flex items-center justify-center'>Guardar</button>
        </div>
          
        </div>
      </div>
  );
};
export default EditData;
